module.exports = __webpack_public_path__ + "7ade1d7fec9d5664e07a9caefb7991f8.pdf";